import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ethers } from 'ethers';
import { SiweMessage } from 'siwe';
import { DataService } from 'app/services/data.service';
import detectEthereumProvider from '@metamask/detect-provider';
import MetaMaskOnboarding from '@metamask/onboarding';
import { AuthenticationService } from 'app/auth/service';
import { Router } from '@angular/router';

declare let window: any;

@Component({
  selector: 'app-wallat-connect',
  templateUrl: './wallat-connect.component.html',
  styleUrls: ['./wallat-connect.component.scss']
})
export class WallatConnectComponent implements OnInit {

  @Output('walletConnected') walletConnected: EventEmitter<boolean> = new EventEmitter();

  private domain: string = window.location.host;
  private origin: string = window.location.origin;
  private provider: ethers.providers.Web3Provider;
  private signer: ethers.providers.JsonRpcSigner;
  private session: string = null;

  public isMetaMaskInstalled: boolean;
  public walletAddress: string = null;

  constructor(private _dataSrv: DataService, private _authenticationService: AuthenticationService, private _router: Router) { }

  ngOnInit(): void {
    this.isMetaMaskInstall().then((status) => {
      if(status){
        this.provider = new ethers.providers.Web3Provider(window.ethereum);
        this.signer = this.provider.getSigner();
        // this.signer.getAddress().then((res) => {
        //   this.walletAddress = res;
        // });
      };
    })
  }


  private async createSiweMessage(address, statement): Promise<any>{
    const res = await this._dataSrv.walletAuth();
    this.session = await res.data.session;
    let nonce = await res.data.nonce;
    const message = new SiweMessage({
      domain: this.domain,
      address,
      statement,
      uri: this.origin,
      version: '1',
      chainId: 1,
      nonce: nonce
    });
    return message.prepareMessage();
  }

  public connectWallet() {
    if(this.isMetaMaskInstalled){
      this.provider.send('eth_requestAccounts', [])
      .then((res) => {
        this.walletAddress = res[0];
        this.signInWithEthereum();
      })
      .catch(() => console.log('user rejected request'));
    } else {
      this.installMetaMask();
    }
  }

  public async signInWithEthereum () {
    const message = await this.createSiweMessage(
        await this.signer.getAddress(),
        'Sign in with Ethereum to the app.'
      );

    const signature = await this.signer.signMessage(message);

    const data = {
      session: this.session,
      message: message,
      signature: signature
    }

    this._dataSrv.walletLogin(data).toPromise().then((res) => {
      // this._router.navigate(['/nft']);
      this._router.navigate(['/crypto']);
      setTimeout(() => {
        localStorage.setItem('currentUser', JSON.stringify(res.data));
        this._authenticationService.currentUserSubject.next(res.data);
      }, 300);
      this.walletConnected.emit(true);
    });
  }

  async isMetaMaskInstall(): Promise<boolean>{
    const provider = await detectEthereumProvider();
    return new Promise((resolve) => {
      if(provider){
        this.isMetaMaskInstalled = true;
        resolve(true);
      } else {
        this.isMetaMaskInstalled = false;
        resolve(false);
      }
    });
  }

  public installMetaMask(){
    const onboarding = new MetaMaskOnboarding();
    onboarding.startOnboarding();
  }

}
